import { post, patch, get } from './requests'
import { getToken } from '_/utils/token'

export const createEmailService = key => (agencyId, payload) => {
  return post(
    ['email-config', agencyId],
    {
      key,
      transformPayload: true,
      transformFormData: true,
      formData: true,
    },
    payload
  )
}

export const editEmailService = key => (agencyId, payload) => {
  return patch(
    ['email-config', agencyId],
    {
      key,
      transformPayload: true,
      transformFormData: true,
      formData: true,
    },
    payload
  )
}

export const testEmailService = key => payload => {
  const config = key ? { key, transformPayload: true } : { ...getToken(), transformPayload: true }

  return post(['test-email-connection'], config, payload)
}

export const getEmailService = key => agencyId =>
  get(['email-config', agencyId], { key, transformPayload: true })

export const sendAgencyTestEmailService = key => (agencyId, payload) => {
  const config = key ? { key, transformPayload: true } : { ...getToken(), transformPayload: true }
  return post(['agency', agencyId, 'send-email-test'], config, payload)
}
